import React from "react";
import { List, Map } from "immutable";

import AppConstants from "../../../constants/AppConstants";
import PanelHeader from "../../../app2components/PanelHeader/PanelHeader";
import LayerPanelCanvasSetBlock from "./LayerPanelCanvasSetBlock";
import LayerPanelCanvasSetAreaMenu from "./LayerPanelCanvasSetAreaMenu";
import LayerPanelCanvasSetDropMarker from "./LayerPanelCanvasSetDropMarker";

const { CANVAS_SET_CHILDREN, CANVAS_SET_BLOCK_CONTENT_SEPARATOR } = AppConstants;

const getCanvasSetBlockList = (canvasSets, id) => {
  const activeCanvasSet =
    canvasSets.filter((canvasSet) => id === canvasSet.get("id")).first() || Map();

  return activeCanvasSet
    .get(CANVAS_SET_CHILDREN, List())
    .filter((item) => item !== CANVAS_SET_BLOCK_CONTENT_SEPARATOR);
};

const CanvasSetLayers = ({ id, blocks, canvasSets, onLayerMove, siteBlocks, onSelect }) => {
  const enumeratedBlocks = blocks.map((item, index) => item.set("index", index));
  const top = enumeratedBlocks.filter((item) => item.get("canvasSetPosition") === "top");
  const bottom = enumeratedBlocks.filter((item) => item.get("canvasSetPosition") === "bottom");
  const canvasSetBlockList = getCanvasSetBlockList(canvasSets, id);

  return (
    <div id="canvas-set-layers">
      <PanelHeader label="Top">
        <LayerPanelCanvasSetAreaMenu
          canvasSetBlockList={canvasSetBlockList}
          canvasSetId={id}
          siteBlocks={siteBlocks}
          area="top"
        />
      </PanelHeader>
      {top.length ? (
        top.map((block) => (
          <LayerPanelCanvasSetBlock
            key={block.get("id")}
            canvasSet={block.get("canvasSet")}
            id={block.get("id")}
            index={block.get("index")}
            layerArea="top"
            block={block}
            onSelect={() => onSelect(block)}
            onLayerMove={onLayerMove}
          />
        ))
      ) : (
        <LayerPanelCanvasSetDropMarker index={0} canvasSet={id} />
      )}
      <PanelHeader label="Bottom">
        <LayerPanelCanvasSetAreaMenu
          canvasSetBlockList={canvasSetBlockList}
          canvasSetId={id}
          siteBlocks={siteBlocks}
        />
      </PanelHeader>
      {bottom.length ? (
        bottom.map((block) => (
          <LayerPanelCanvasSetBlock
            key={block.get("id")}
            canvasSet={block.get("canvasSet")}
            id={block.get("id")}
            index={block.get("index") + 1}
            layerArea="bottom"
            block={block}
            onLayerMove={onLayerMove}
            onSelect={() => onSelect(block)}
          />
        ))
      ) : (
        <LayerPanelCanvasSetDropMarker index={top.length + 1} canvasSet={id} />
      )}
    </div>
  );
};

export default CanvasSetLayers;
